import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/pay/payRefundAudit/page', Object.assign({}, options, { params }));

export const getOrderDetail = (params, options) =>
  request.get('/api/v4ward/pay/payTrade/detail', Object.assign({}, options, { params }));

export const getAuditDetail = (params, options) =>
  request.get('/api/v4ward/pay/payRefundAudit/auditDetail', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/pay/payRefundAudit/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/pay/payRefundAudit/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/pay/payRefundAudit/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/pay/payRefundAudit/submit', params, options);

export const audit = (params, options) =>
  request.post('/api/v4ward/pay/payRefundAudit/audit', params, options);

export const reject = (params, options) =>
  request.post('/api/v4ward/pay/payRefundAudit/reject', params, options);
